module.exports = __webpack_public_path__ + "img/step2-1.cc427769.png";